<interacta-user-notification [notification]="notification()">
    @if (expiration(); as expiration) {
        <div
            class="mt-8 h-24 w-max rounded-3xl bg-surface-B px-8 py-4 typo-xs"
            matTooltipPosition="above"
            [matTooltip]="expiration | dateTooltip"
        >
            <span>
                {{ expiration | taskExpirationDate }}
            </span>
        </div>
    }
</interacta-user-notification>
